import './Hero.css'

const IconGlobe = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="9"/>
    <path d="M3 12h18M12 3c2.5 2.5 4 5.5 4 9s-1.5 6.5-4 9c-2.5-2.5-4-5.5-4-9s1.5-6.5 4-9z"/>
  </svg>
)

const IconArrow = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14M13 6l6 6-6 6"/>
  </svg>
)

export default function Hero({ onViewListings = () => {} }) {
  return (
    <section className="hero">
      <div className="hero-inner">

        {/* Chip */}
        <div className="hero-chip">
          <IconGlobe />
          Livraison internationale disponible
        </div>

        {/* Titre */}
        <h1 className="hero-title">
          Trouvez votre <span>compagnon idéal</span>
          <br />parmi nos annonces certifiées
        </h1>

        {/* Sous-titre */}
        <p className="hero-sub">
          Des milliers d'annonces de chiens, chats, oiseaux et plus encore.
          Éleveurs professionnels et particuliers vérifiés. Animaux vaccinés,
          pucés, avec pédigrée.
        </p>

        {/* CTA */}
        <button className="hero-cta" onClick={onViewListings}>
          Voir les annonces
          <IconArrow />
        </button>

      </div>

      <div className="hero-curve" />
    </section>
  )
}